import { QUERY_KEYS } from 'api/query-keys';
import { workTemplateService } from 'ogp/services';
import { UpdateWorkTemplatePayload } from 'ogp/services/work-template-service.types';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

type UpdateWorkTemplateParams = UpdateWorkTemplatePayload & { id: string };

type WorkTemplateMutationOptions = UseMutationOptions<unknown, unknown, UpdateWorkTemplateParams>;

export const useUpdateWorkTemplate = () => {
  const mutationFn = async ({ id, ...payload }: UpdateWorkTemplateParams) =>
    await workTemplateService.updateWorkTemplate(id, payload);

  const queryClient = useQueryClient();
  const mutationOptions: WorkTemplateMutationOptions = {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.workTemplates());
    },
  };

  return useMutation(mutationFn, mutationOptions);
};
